import React, { FC } from 'react'

import SkeletonStory from './SkeletonStory'

import './Skeleton.scss'

const SkeletonStories: FC = () => (
  <>
    <SkeletonStory />
    <SkeletonStory />
    <SkeletonStory />
    <SkeletonStory />
  </>
)

export default SkeletonStories
